import { Injectable } from '@angular/core';

import { Observable ,  Subscription } from 'rxjs';
import { share } from 'rxjs/operators';

import { AuthService } from 'app/user/auth.service';
import { OrderListService } from 'app/orders/orders.service';
import { MixpanelNotificationsSource } from 'app/notifications/mixpanel/mixpanel-notifications-source';
import { Notification } from './notification';
import { pascalCase } from 'app/core/case-transform';

@Injectable()
export class NotificationsService {

    private hasOrdersSubscription: Subscription;

    private mixpanel = (<any>window).mixpanel;

    constructor(
        authService: AuthService,
        orderListService: OrderListService,
        private notificationsSource: MixpanelNotificationsSource) {
        authService
            .isAuth
            .subscribe(isAuth => {
                if (this.hasOrdersSubscription) {
                    this.hasOrdersSubscription.unsubscribe();
                }

                if (isAuth) {
                    this.hasOrdersSubscription = orderListService
                        .hasOrders()
                        .subscribe(hasOrders => this.sendHasOrders(hasOrders));
                }
            });
    }

    getNotifications(): Observable<Notification[]> {
        return this.notificationsSource.getNotifications().pipe(share());
    }

    markAsRead(notifications: Notification[]): void {
        this.notificationsSource.markAsRead(notifications);
    }

    close(notification: Notification) {
        this.notificationsSource.close(notification);
    }

    private sendHasOrders(hasOrders: boolean): void {
        if (!hasOrders) {
            return;
        }

        this.hasOrdersSubscription.unsubscribe();

        this.mixpanel.people.set({
            'Has Orders': pascalCase(hasOrders.toString())
        });
    }
}